var map = {
	"./ADA.svg": "./src/assets/currencies/ADA.svg",
	"./BTC.svg": "./src/assets/currencies/BTC.svg",
	"./BWP.svg": "./src/assets/currencies/BWP.svg",
	"./CAD.svg": "./src/assets/currencies/CAD.svg",
	"./CDF.svg": "./src/assets/currencies/CDF.svg",
	"./CUSD.svg": "./src/assets/currencies/CUSD.svg",
	"./ETH.svg": "./src/assets/currencies/ETH.svg",
	"./GHS.svg": "./src/assets/currencies/GHS.svg",
	"./KES.svg": "./src/assets/currencies/KES.svg",
	"./LSL.svg": "./src/assets/currencies/LSL.svg",
	"./LTC.svg": "./src/assets/currencies/LTC.svg",
	"./MATIC.svg": "./src/assets/currencies/MATIC.svg",
	"./MWK.svg": "./src/assets/currencies/MWK.svg",
	"./NGN.svg": "./src/assets/currencies/NGN.svg",
	"./PYUSD.svg": "./src/assets/currencies/PYUSD.svg",
	"./RLUSD.svg": "./src/assets/currencies/RLUSD.svg",
	"./RWF.svg": "./src/assets/currencies/RWF.svg",
	"./SOL.svg": "./src/assets/currencies/SOL.svg",
	"./TON.svg": "./src/assets/currencies/TON.svg",
	"./TRX.svg": "./src/assets/currencies/TRX.svg",
	"./TZS.svg": "./src/assets/currencies/TZS.svg",
	"./UGX.svg": "./src/assets/currencies/UGX.svg",
	"./USD.svg": "./src/assets/currencies/USD.svg",
	"./USDC.svg": "./src/assets/currencies/USDC.svg",
	"./USDT.svg": "./src/assets/currencies/USDT.svg",
	"./XAF.svg": "./src/assets/currencies/XAF.svg",
	"./XAUT.svg": "./src/assets/currencies/XAUT.svg",
	"./XLM.svg": "./src/assets/currencies/XLM.svg",
	"./XOF.svg": "./src/assets/currencies/XOF.svg",
	"./XRP.svg": "./src/assets/currencies/XRP.svg",
	"./ZAR.svg": "./src/assets/currencies/ZAR.svg",
	"./ZMW.svg": "./src/assets/currencies/ZMW.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/currencies sync recursive ^\\.\\/.*\\.svg$";